import { jsx as _jsx } from "react/jsx-runtime";
import { HcPill } from '@hotmart-org-ca/cosmos-web/dist/react/hc-pill';
export function Tab({ active, children }) {
    return _jsx(HcPill, { active: active, children: children });
}
